// CustomerFollowupList

import React, { Component } from "react";
import axios from "axios";
import { format } from "date-fns";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import { save } from "save-file";
import Loading from "../Loading";
import CustomerFollowupForm from "./CustomerFollowupForm";
import { APIURL } from "../../config/config";
import { AlertSuccess, AlertWarning, AlertError } from "../Alert/Alert";
import BDatePicker from "../BDatePicker";
import "react-vertical-timeline-component/style.min.css";
import { connect } from "react-redux";
import { CustomerFollowupUtils } from "./CustomerFollowupUtils";
import {
  checkGroupPermission,
  getGroupPermission,
} from "../../services/grouppermission";

class CustomerFollowupList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenFollowupForm: false,
      customer_id: null,
      followup_id: null,
      leads: [],
      followups: [],
      isLoading: false,
      customer: null,
      admin_followup_by: null,
      user: JSON.parse(this.props.user),
      menuID: [3502],
      grouppermissions: [],
      customer_types: [],
      customer_type_leads: ["lead", "wait", "appointment", "deciding"],
      // Edit followup states
      editingFollowupId: null,
      editFormData: {
        contact_date: null,
        followup_date: null,
        followup_detail: "",
        followup_next: "",
      },
    };
    this.loadCustomerLead = this.loadCustomerLead.bind(this);
    this.loadCustomerFollowUp = this.loadCustomerFollowUp.bind(this);
    this.loadGroupPermission = this.loadGroupPermission.bind(this);
    this.exportExcel = this.exportExcel.bind(this);
    this.loadCustomerTypes = this.loadCustomerTypes.bind(this);
    this.getCustomerTypeName = this.getCustomerTypeName.bind(this);
    // Edit followup methods
    this.handleEditFollowup = this.handleEditFollowup.bind(this);
    this.handleSaveFollowup = this.handleSaveFollowup.bind(this);
    this.handleCancelEdit = this.handleCancelEdit.bind(this);
    this.handleEditInputChange = this.handleEditInputChange.bind(this);
  }

  /*componentWillMount () {
    const queryString = require('query-string');
    let query = queryString.parse(this.props.location.search);
    
  }*/

  loadGroupPermission() {
    let type = this.state.user.type;
    let menuID = this.state.menuID;

    getGroupPermission(type, menuID).then((res) => {
      if (res.data.result === "success") {
        this.setState({
          grouppermissions: res.data.grouppermissions,
        });
      }
    });
  }

  componentDidMount() {
    this.loadGroupPermission();
    this.loadCustomerTypes();
    try {
      const queryString = require("query-string");
      let query = queryString.parse(this.props.location.search);
      let followup_by = query.followup_by;

      // กดดูรายละเอียด โดย admin
      this.setState(
        {
          admin_followup_by: followup_by,
        },
        () => this.loadCustomerLead()
      );
    } catch (e) {
      let username = this.state.user.user;
      this.setState(
        {
          admin_followup_by: username,
        },
        () => this.loadCustomerLead()
      );

      //this.loadCustomerLead()
    }
  }

  loadCustomerTypes() {
    axios
      .get(APIURL + "/customer/followup/customer_types")
      .then((res) => {
        this.setState({ customer_types: res.data });
      })
      .catch((error) => {
        this.setState({ customer_types: [] });
      });
  }

  loadCustomerLead() {
    let username = this.state.user.user;
    let type = this.state.user.type;
    let admin_followup_by = this.state.admin_followup_by;

    if (admin_followup_by !== null) {
      // console.log('admin load by user')
      let uri = APIURL + "/customer/followup/user/" + admin_followup_by;
      axios.get(uri).then((res) => {
        // admin แสดง lead ของ user ทุกสถานะ

        this.setState({ leads: res.data }, () => {
          if (res.data.length !== 0) {
            let customer = res.data[0];
            this.loadCustomerFollowUp(customer);
          }
        });
      });
    } else {
      if (type === "admin") {
        // console.log('admin load all no select user')
        // for admin
        let uri = APIURL + "/customer/followup/admin";
        axios.get(uri).then((res) => {
          this.setState({ leads: res.data }, () => {
            if (res.data.length !== 0) {
              let customer = res.data[0];
              this.loadCustomerFollowUp(customer);
            }
          });
        });
      } else if (username !== undefined) {
        // console.log('user load : ', username)
        let uri = APIURL + "/customer/followup/user/" + username;
        axios.get(uri).then((res) => {
          // show เฉพาะ lead ของ sale

          let customer_type_leads = this.state.customer_type_leads;
          let customers = res.data.filter((customer) => {
            return customer_type_leads.includes(customer.customer_type);
          });
          this.setState({ leads: customers }, () => {
            if (customers.length !== 0) {
              let customer = customers[0];
              this.loadCustomerFollowUp(customer);
            }
          });
        });
      }
    }
  }

  loadCustomerFollowUp(customer) {
    let customer_id = customer.customer_id;

    this.setState({
      isLoading: true,
    });
    setTimeout(() => {
      let uri = APIURL + "/customer/followup/lead/" + customer_id;

      axios.get(uri).then((res) => {
        this.setState({
          customer: customer,
          followups: res.data,
          isLoading: false,
        });
      });
    }, 1200);
  }

  exportExcel() {
    let username = this.state.user.user;
    let admin_followup_by = this.state.admin_followup_by;

    if (admin_followup_by !== null) {
      username = admin_followup_by;
    }

    let data = {
      username,
    };

    this.setState({
      isLoading: true,
    });

    let uri = APIURL + "/customer/followup/excel";
    axios
      .post(uri, data)
      .then(async (res) => {
        const excelBuffer = res.data.excelBuffer;
        const currentDatetime = res.data.currentDatetime;
        const fileName =
          "รายการติดตามลูกค้า_export_" + currentDatetime + ".xlsx";
        this.setState({
          isLoading: false,
        });
        await save(excelBuffer, fileName);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getCustomerTypeName(customer_types, customer_type) {
    let data = customer_types.filter((c) => c.customer_type === customer_type);
    if (data.length === 0) {
      return "";
    }
    return data[0].customer_type_name;
  }

  // Edit followup handler methods
  handleEditFollowup(followup) {
    this.setState({
      editingFollowupId: followup.id,
      editFormData: {
        contact_date: followup.contact_date,
        followup_date: followup.followup_date,
        followup_detail: followup.followup_detail,
        followup_next: followup.followup_next,
      },
    });
  }

  handleSaveFollowup() {
    const { editingFollowupId, editFormData } = this.state;
    const { contact_date, followup_date, followup_detail, followup_next } = editFormData;

    // Validation
    if (!contact_date || !followup_date || !followup_detail || !followup_next) {
      AlertWarning("กรุณากรอกข้อมูลให้ครบถ้วน");
      return;
    }

    if (new Date(contact_date) > new Date(followup_date)) {
      AlertWarning("วันที่ติดต่อต้องไม่เกินวันที่นัดหมาย");
      return;
    }

    this.setState({ isLoading: true });

    const data = {
      contact_date,
      followup_date,
      followup_detail,
      followup_next,
      username: this.state.user.user,
    };

    const uri = APIURL + "/customer/followup/" + editingFollowupId;
    axios
      .put(uri, data)
      .then((res) => {
        if (res.data.result === "success") {
          AlertSuccess("แก้ไขข้อมูลการติดตามเรียบร้อยแล้ว");
          this.setState({
            editingFollowupId: null,
            editFormData: {
              contact_date: null,
              followup_date: null,
              followup_detail: "",
              followup_next: "",
            },
            isLoading: false,
          });
          // Reload followup data
          if (this.state.customer) {
            this.loadCustomerFollowUp(this.state.customer);
          }
        }
      })
      .catch((error) => {
        console.log("error:", error);
        AlertError("เกิดข้อผิดพลาดในการบันทึกข้อมูล");
        this.setState({ isLoading: false });
      });
  }

  handleCancelEdit() {
    this.setState({
      editingFollowupId: null,
      editFormData: {
        contact_date: null,
        followup_date: null,
        followup_detail: "",
        followup_next: "",
      },
    });
  }

  handleEditInputChange(field, value) {
    this.setState({
      editFormData: {
        ...this.state.editFormData,
        [field]: value,
      },
    });
  }

  render() {
    let user = this.state.user;
    const {
      isOpenFollowupForm,
      customer_id,
      followup_id,
      leads,
      followups,
      customer,
      customer_types,
    } = this.state;

    //  {/*  <i className="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i>*/}
    let card_leads = leads.map((lead, index) => (
      <div key={index} className="card">
        <div className="card-header font-weight-bold">
          <div className="row">
            <div className="col-8">
              {" "}
              {lead.customer_name} {lead.customer_lastname}
              <br/>
              โทร.{lead.customer_mobile}{" "}
            </div>
            <div className="col-4 text-right">
              <span
                className={CustomerFollowupUtils.getClassBadge(
                  lead.customer_type
                )}
              >
                {this.getCustomerTypeName(customer_types, lead.customer_type)}
              </span>
            </div>
          </div>
        </div>
        <div className="card-block p-2 clearfix">
          <div className="text-primary font-weight-bold mb-0 mt-2">
            รายละเอียดลูกค้า : {lead.customer_note}
          </div>
          <div className="text-muted text-uppercase font-weight-bold text-success mt-2">
            รถที่สนใจ : {lead.car_type_interest}
            &nbsp; &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; ลูกค้าจาก :{" "}
            {lead.profile_from === null ? "-" : lead.profile_from}
          </div>
          <div className="text-muted text-uppercase font-weight-bold text-danger mt-2">
            ระดับความต้องการ :{" "}
            {lead.walkin_level === null || lead.walkin_level === ""
              ? "-"
              : lead.walkin_level}
          </div>
          <div className="text-muted text-uppercase font-weight-bold mt-2">
            เพิ่มโดย : {lead.user_updated}
            &nbsp; &nbsp; ติดตามโดย :{" "}
            <span className="badge badge-info"> {lead.followup_by} </span>
          </div>

          <div className="text-muted text-uppercase font-weight-bold mt-2">
            เมื่อ : {format(new Date(lead.updated_at), "dd/MM/yyyy HH:mm:ss")}
          </div>
        </div>
        <div className="card-footer px-2 py-2">
          <a
            className="font-weight-bold font-xs btn-block"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              this.loadCustomerFollowUp(lead);
            }}
          >
            รายละเอียดการติดตาม{" "}
            <i className="fa fa-angle-right float-right font-lg"></i>
          </a>
        </div>
      </div>
    ));

    // vertical-timeline-element-title
    // icon={<i className="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left" />}
    // background: 'rgb(33, 150, 243)'
    // date={followup.followup_times}
    let timeline_followups = followups.map((followup, index) => {
      let count = followups.length;
      let times = count - index;
      const isEditing = this.state.editingFollowupId === followup.id;
      const { editFormData } = this.state;

      return (
        <VerticalTimelineElement
          key={index}
          className="vertical-timeline-element-work"
          contentStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
          contentArrowStyle={{ borderRight: "7px solid  rgb(33, 150, 243)" }}
          iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
        >
          <strong><span className="vertical-timeline-element-subtitle">
            ครั้งที่ : {times}
          </span>
          </strong>
          {!isEditing ? (
            // View Mode
            <>
              <br/>
              <strong><span className="vertical-timeline-element-subtitle mt-2">
                วันที่นัดหมาย:{" "}
                {format(new Date(followup.followup_date), "dd/MM/yyyy")}
              </span>
              </strong>
              <br/>
              <strong><span className="vertical-timeline-element-subtitle mt-1">
                วันที่ติดต่อ:{" "}
                {format(new Date(followup.contact_date), "dd/MM/yyyy")}
              </span>
              </strong>
              <hr />
              <div>
                รายละเอียดการติดต่อ: <br />
                {followup.followup_detail}
              </div>
              <div className="mt-2">
                หัวข้อการติดตามครั้งถัดไป: <br />
                {followup.followup_next}
              </div>
              <div className="text-muted text-uppercase font-weight-bold mt-2">
                โดย : {followup.user_updated} <br />
                เมื่อ :{" "}
                {format(new Date(followup.updated_at), "dd/MM/yyyy HH:mm:ss")}
              </div>

              {/* Edit button */}
              {checkGroupPermission(3502, this.state.grouppermissions).modified && (
                <div className="mt-3 text-right">
                  <button
                    className="btn btn-warning btn-sm"
                    onClick={() => this.handleEditFollowup(followup)}
                  >
                    <i className="icon-pencil"></i> แก้ไข
                  </button>
                </div>
              )}
            </>
          ) : (
            // Edit Mode
            <div>
              <div className="form-group mt-2">
                <label className="text-white">วันที่ติดต่อ:</label>
                <BDatePicker
                  isDateFill={0}
                  name="contact_date"
                  value={editFormData.contact_date}
                  label=""
                  onUpdateDate={(buddhist_date, christ_date) => {
                    this.handleEditInputChange("contact_date", christ_date);
                  }}
                />
              </div>

              <div className="form-group mt-2">
                <label className="text-white">วันที่นัดหมาย:</label>
                <BDatePicker
                  isDateFill={0}
                  name="followup_date"
                  value={editFormData.followup_date}
                  label=""
                  onUpdateDate={(buddhist_date, christ_date) => {
                    this.handleEditInputChange("followup_date", christ_date);
                  }}
                />
              </div>

              <div className="form-group mt-2">
                <label className="text-white">รายละเอียดการติดต่อ:</label>
                <textarea
                  className="form-control"
                  rows="3"
                  value={editFormData.followup_detail}
                  onChange={(e) => this.handleEditInputChange("followup_detail", e.target.value)}
                />
              </div>

              <div className="form-group mt-2">
                <label className="text-white">หัวข้อการติดตามครั้งถัดไป:</label>
                <input
                  type="text"
                  className="form-control"
                  value={editFormData.followup_next}
                  onChange={(e) => this.handleEditInputChange("followup_next", e.target.value)}
                />
              </div>

              <div className="mt-3 text-right">
                <button
                  className="btn btn-secondary btn-sm mr-2"
                  onClick={() => this.handleCancelEdit()}
                >ยกเลิก
                </button>
                <button
                    className="btn btn-success btn-sm"
                    onClick={() => this.handleSaveFollowup()}
                >บันทึก
                </button>
              </div>
            </div>
          )}
        </VerticalTimelineElement>
      );
    });

    let customer_info =
      customer !== null
        ? customer.customer_name +
          " " +
          customer.customer_lastname +
          " โทร." +
          customer.customer_mobile
        : "-";

    return (
      <div className="row">
        {isOpenFollowupForm && (
          <CustomerFollowupForm
            user={user}
            admin_followup_by={this.state.admin_followup_by}
            customer_id={customer_id}
            followup_id={followup_id}
            isOpen={isOpenFollowupForm}
            onToggle={(is_reload) => {
              if (is_reload) {
                this.setState(
                  {
                    isOpenFollowupForm: !this.state.isOpenFollowupForm,
                    customer_id: null,
                    followup_id: null,
                    leads: [],
                    followups: [],
                    customer: null,
                  },
                  () => {
                    this.loadCustomerLead();
                    if (this.state.admin_followup_by === null) {
                      this.props.onCalendarReload(is_reload);
                    }
                  }
                );
              } else {
                this.setState({
                  isOpenFollowupForm: !this.state.isOpenFollowupForm,
                  customer_id: null,
                  followup_id: null,
                });
              }
            }}
          />
        )}

        <Loading isLoading={this.state.isLoading} />

        <div className="col-sm-12 col-md-12">
          <div className="card card-accent-info">
            <div className="card-header">
              <div className="row">
                <div className="col-6 ">
                  <strong> ข้อมูลการติดตาม </strong>
                </div>
                <div className="col-6 text-right">
                  {checkGroupPermission(3502, this.state.grouppermissions)
                    .printed ? (
                    <button
                      className="btn btn-success mr-2"
                      style={{
                        height: 38,
                        paddingTop: 0,
                        paddingBottom: 0,
                        display: "inline",
                        marginTop: 0,
                      }}
                      onClick={() => {
                        this.exportExcel();
                      }}
                    >
                      <i className="icon-paper-clip" /> &nbsp; Excel &nbsp;
                      &nbsp;
                    </button>
                  ) : null}

                  {checkGroupPermission(3502, this.state.grouppermissions)
                    .created ? (
                    <button
                      className="btn btn-primary"
                      style={{
                        height: 38,
                        paddingTop: 0,
                        paddingBottom: 0,
                        display: "inline",
                        marginTop: 0,
                      }}
                      onClick={() => {
                        this.setState({
                          isOpenFollowupForm: true,
                        });
                      }}
                    >
                      <i className="icon-plus" /> &nbsp; เพิ่มการติดตามใหม่
                    </button>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="card-block">
              <div className="row">
                <div className="col-5">
                  <div className="card card-accent-primary">
                    <div className="card-header ">ลูกค้า (Lead) / ผู้สนใจ</div>
                    <div className="card-block p-3">{card_leads}</div>
                  </div>
                </div>
                <div className="col-7">
                  <div className="card card-accent-success">
                    <div className="card-header ">รายละเอียดการติดตาม</div>
                    <div className="card-block">
                      <div className="row">
                        <div className="col-7">
                          ลูกค้า(Lead) : {customer_info}
                        </div>
                        <div className="col-5">
                          {customer !== null &&
                          checkGroupPermission(
                            3502,
                            this.state.grouppermissions
                          ).modified ? (
                            <button
                              className="btn btn-primary"
                              style={{
                                height: 38,
                                paddingTop: 0,
                                paddingBottom: 0,
                                display: "inline",
                                marginTop: 0,
                              }}
                              onClick={() => {
                                this.setState({
                                  isOpenFollowupForm: true,
                                  customer_id: customer.customer_id,
                                  followup_id: null,
                                });
                              }}
                            >
                              <i className="icon-plus"></i> &nbsp;
                              เพิ่มการติดตาม {customer.customer_name}
                            </button>
                          ) : null}
                        </div>
                      </div>
                      <div className="row col-12">
                        <VerticalTimeline
                          layout={"2-columns"}
                          lineColor={"rgb(33, 150, 243)"}
                        >
                          {timeline_followups}
                        </VerticalTimeline>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(CustomerFollowupList);
